module.exports = __webpack_public_path__ + "img/14_no.96094733.svg";